export const PER_PAGE = 10

export const COMPLETED_PROTRACKS_PAGINATION = 4
